import axios from "axios";

import store from "../../store";
import { APIBaseUrl } from "../constance";
import { decryptData, encryptData } from "../../helper/common";
import { handleAxiosError, logoutUser } from "../../store/user/user-action";

export const defaultAxios = axios.create({
  baseURL: APIBaseUrl,
  validateStatus: function (status) {
    // Accept all responses with status < 500 as "successful"
    return status < 500;
  },
});

// Request interceptor for authorization token
defaultAxios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state?.user?.token ?? "";
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Encrypt the payload
    // if (config.data) {
    //   const encrypted = encryptData(config.data);
    //   config.data = { payload: encrypted }; // wrap in object to match expected server format
    // }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

defaultAxios.interceptors.response.use(
  async (response) => {
    if (response.status == 401) {
      const dispatch = store.dispatch;
      return logoutUser(dispatch);
      // return await handleAxiosError(response, dispatch, token);
    } else {
      if (response.data && response.data) {
        // old
        // let custObj = {};
        // const decryptedData = decryptData(
        //   response.data.data || response.data.Data
        // );
        // custObj = { ...response.data, data: JSON.parse(decryptedData) };
        // return custObj || response.data;

        // new
        let custObj = {};
        const decryptedData = decryptData(response.data);

        custObj = {
          ...response.data,
          data:
            typeof decryptedData === "object"
              ? decryptedData
              : JSON.parse(decryptedData),
        };
        return custObj || response.data;
      }

      return response.data;
    }
  },
  async (error) => {
    // console.log("🚀 ~ error:", error);
    // if (error.status !== 500) {
    //   const dispatch = store.dispatch;
    //   // const state = store.getState();
    //   // const token = state?.user?.token ?? "";
    //   return logoutUser(dispatch);

    //   // return await handleAxiosError(error, dispatch, token);
    // }

    // showToast.error(error?.message || "Invalid data");

    return false;
  },
);
